import { a as o_global } from "../chunks/common-namespaces-client-DXKc2YAH.mjs";
import { o as otto } from "../chunks/common-nexus-client-CLQM3FGj.mjs";
const debugSync = o_global.debug ?? {};
const logger = debugSync.logger;
const scope = debugSync.scope;
const Level = debugSync.Level;
const status = debugSync.status;
const sendLog = (otto.apm ?? {}).sendCustomError;
export {
  Level,
  debugSync,
  logger,
  scope,
  sendLog,
  status
};
/*                                     */
